import {TableActionsColumnName} from './types'

export const TABLE_ACTIONS_COLUMN_NAME: TableActionsColumnName = 'tableActions' as const
export const TABLE_RECOMMENDED_DEFAULT_ROWS_PER_PAGE = 25 as const
